export default function Location() {
  return (
    <section id="location" className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">
          所在地・アクセス
        </h2>
        <p className="text-center text-gray-700 font-normal text-base leading-relaxed mb-12">
          江田島市全域に<br className="md:hidden" />対応しております。<br />
          呉市からも<br className="md:hidden" />アクセス可能です。
        </p>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="aspect-video w-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.8!2d132.4583365!3d34.1733897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x355aac1a3aa63cbd%3A0x12289f78e102ab5b!2z44CSNzM3LTIyMTMg5bqD5bO255yM5rGf55Sw5bO25biC5aSn5p-_55S65aSn5Y6f77yR77yR77yZ77yZ4oiS77yV!5e0!3m2!1sja!2sjp!4v1234567892"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="広島県江田島市大柿町大原1199-5の地図"
            ></iframe>
          </div>

          <div className="p-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-cyan-100 rounded-full flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-cyan-600"></i>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-2">所在地</h3>
                <p className="text-base text-gray-700 font-normal leading-relaxed">広島県江田島市大柿町大原1199-5</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-cyan-100 rounded-full flex-shrink-0">
                <i className="ri-car-line text-2xl text-cyan-600"></i>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-2">アクセス</h3>
                <p className="text-base text-gray-700 font-normal leading-relaxed">
                  江田島市全域に対応しております。<br />
                  呉市からもアクセス可能です。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
